import React, { FC } from 'react';
import { IonList, IonListHeader, IonIcon, IonLabel, IonItem } from '@ionic/react';
import { FormattedMessage } from 'react-intl';

import { timeOutline } from 'ionicons/icons';

import classes from './RobotEdit.module.css';
import Messages from './RobotEdit.messages';
import { Device, UVDMongoDevice } from '../../types/types';

interface RobotActivityProps {
	robotId: string;
	orgId: string;
	device: UVDMongoDevice;
}

const RobotActivity: FC<RobotActivityProps> = props => {
	const { device } = props;

	return (
		<div className={classes.recentContainer}>
			<IonList lines="none">
				<IonListHeader>
					<IonIcon color="primary" size="small" icon={timeOutline} />
					<IonLabel color="primary" className={classes.recentLb}>
						<FormattedMessage {...Messages.recentActivity} />
					</IonLabel>
				</IonListHeader>
				<IonItem />
			</IonList>
		</div>
	);
};

export default RobotActivity;
